module.exports = "/images/marker-shop.png?3c126f59c52f922ff04adc484d359596";